// extracted by mini-css-extract-plugin
export default {"container":"LanguageSwitcher_container__zq7S9"};